import React, { useState } from 'react';
import './AddEquipamentosForm.css';
import { apiService } from '../../../services/ApiService';

const AddEquipamentosForm = ({ obraId, onClose, onSuccess }) => {
  const [dados, setDados] = useState({
    nomeEquipamento: '',
    quantidade: 1,
    horasUtilizadas: 0,
    fornecedor: '',
    observacao: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Manipula alterações nos campos de texto
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDados(prevDados => ({
      ...prevDados,
      [name]: value
    }));
  };
  
  // Manipula alterações em campos numéricos
  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    
    // Converte valores para número
    const numericValue = name === 'quantidade' 
      ? parseInt(value, 10)
      : parseFloat(value);
    
    setDados(prevDados => ({
      ...prevDados,
      [name]: numericValue
    }));
  };

  // Manipula o envio do formulário
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!dados.nomeEquipamento) {
      setError('Por favor, informe o nome do equipamento.');
      return;
    }

    if (dados.quantidade <= 0) {
      setError('A quantidade deve ser maior que zero.');
      return;
    }

    try {
      setIsSubmitting(true);
      setError(null);
      
      // Enviar para a API usando o mesmo método que é usado para fotos,
      // mas com o tipo "equipamentos"
      const response = await apiService.addDiarioObraMedia(
        obraId,
        'equipamentos',
        dados
      );

      if (response.success) {
        console.log("Equipamento adicionado com sucesso:", response);
        
        // Criar um objeto de registro
        const registroProcessado = response.registro || {
          id: response.id || Date.now().toString(),
          dados: dados,
          data: new Date().toISOString()
        };
        
        if (onSuccess) {
          onSuccess(registroProcessado);
        }
        onClose();
      } else {
        setError(response.error || 'Erro ao adicionar equipamento. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro ao adicionar equipamento:', error);
      setError('Ocorreu um erro ao adicionar o equipamento. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="equipamentos-form-container">
      {error && (
        <div className="equipamentos-form-error">
          <i className="fas fa-exclamation-circle"></i> {error}
        </div>
      )}

      <form className="equipamentos-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="nomeEquipamento">Nome do Equipamento*</label>
          <input
            type="text"
            id="nomeEquipamento"
            name="nomeEquipamento"
            value={dados.nomeEquipamento}
            onChange={handleInputChange}
            placeholder="Ex: Retroescavadeira"
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="quantidade">Quantidade*</label>
            <input
              type="number"
              id="quantidade"
              name="quantidade"
              value={dados.quantidade}
              onChange={handleNumberChange}
              min="1"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="horasUtilizadas">Horas Utilizadas*</label>
            <input
              type="number"
              id="horasUtilizadas"
              name="horasUtilizadas"
              value={dados.horasUtilizadas}
              onChange={handleNumberChange}
              min="0"
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="fornecedor">Fornecedor (opcional)</label>
          <input
            type="text"
            id="fornecedor"
            name="fornecedor"
            value={dados.fornecedor}
            onChange={handleInputChange}
            placeholder="Nome do fornecedor do equipamento"
          />
        </div>

        <div className="form-group">
          <label htmlFor="observacao">Observação</label>
          <textarea
            id="observacao"
            name="observacao"
            value={dados.observacao}
            onChange={handleInputChange}
            placeholder="Observações adicionais sobre o equipamento"
            rows="3"
          ></textarea>
        </div>

        <div className="equipamentos-form-actions">
          <button 
            type="button" 
            className="btn-cancel" 
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancelar
          </button>
          <button 
            type="submit" 
            className="btn-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <div className="spinner-small"></div>
                <span>Enviando...</span>
              </>
            ) : (
              <>
                <i className="fas fa-save"></i>
                <span>Salvar</span>
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddEquipamentosForm; 